import React, {PropTypes} from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import DisplayIf from 'shared/DisplayIf.jsx';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEntryDetail = ({
  id,
  bowlerId,
  bowlerName,
  usbcId,
  entryId,
  position,
  divisionName,
  bowlers,
  teams,
  balance,
  selected,
  isCancelled,
  onBowlerChange,
  onTeamChange,
  onSelectChecked,
  onCancelClick,
  onReactivateClick,
  onRefundClick
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child"
      style={{width: 45}}>
      <div className="custom-checkbox-container">
        { isCancelled
          ? null
          : <div>
              <input
                type="checkbox"
                id={`entry-${id}`}
                checked={selected}
                onChange={() => onSelectChecked(id)}
              />
              <label
                htmlFor={`entry-${id}`} />
            </div>
        }
      </div>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 45}}>
      <span>{'Entry'}</span>
      <span>{position}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 300}}>
      {
        isCancelled
        ? <strong
            className="list-group-item-labeled-child"
            style={{marginTop: 10, alignItems: 'center'}}>CANCELLED</strong>
        :
        <div>
          { teams.length ?
          <div>
            <span>{'Team'}</span>
            <Select
              name={`team-${position}`}
              options={teams.map(x => ({
                        value: x.id,
                        label: x.description
                      }))}
              value={entryId}
              simpleValue
              searchable
              onChange={value => onTeamChange(id, value)}
            />
          </div>
          :
          <div>
            <span>{'Bowler'}</span>
            <Select
              name={`bowler-${position}`}
              options={bowlers.map(x => ({
                        value: x.id,
                        label: x.description
                      }))}
              placeholder={bowlerId ? `${bowlerName} (${usbcId})` : 'Select...'}
              value={bowlerId}
              simpleValue
              searchable
              onChange={value => onBowlerChange(id, value)}
            />
            <DisplayIf condition={bowlers.find(b => b.id == bowlerId) ? bowlers.find(b => b.id == bowlerId).assignedByOtherCaptain : false}>
              <span className="btn btn-danger" 
                disabled 
                style={{ opacity: 1, marginTop: 5, width: 460, color: '#FFF' }}>
                {'Bowler already entered into All Events by another captain'}
              </span>
            </DisplayIf>
          </div>
          }
        </div>
      }
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <span>{'Division'}</span>
      <span>{divisionName}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <div className={classNames(
        'list-group-item-labeled-child',
        {'bg-danger': balance && !isCancelled},
        {'bg-warning': isCancelled}
      )}
        style={{width: 145, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 20}}>
        {
          balance
          ? <strong className="flex center" >{`$${balance.formatCurrency(2)} ${isCancelled ? 'BALANCE' : 'DUE'}`}</strong>
          : null
        }
      </div>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 135}}>
      { !isCancelled && !balance
        ? <button className="btn btn-default btn-lg"
            style={{height: 40}}
            onClick={() => onRefundClick(id)}>Refund</button>
        : null
      }
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 135}}>
      {isCancelled
        ? <button className="btn btn-default btn-lg"
            style={{height: 40}}
            onClick={() => onReactivateClick(id)}>Reactivate</button>
        : <button className="btn btn-default btn-lg"
            style={{height: 40}}
            onClick={() => onCancelClick(id)}>Cancel</button>
      }
    </div>
  </div>
);

VirtualEntryDetail.propTypes = {
  id: PropTypes.string.isRequired,
  bowlerId: PropTypes.string,
  bowlerName: PropTypes.string,
  divisionName: PropTypes.string,
  usbcId: PropTypes.string,
  entryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  bowlers: PropTypes.arrayOf(PropTypes.object),
  teams: PropTypes.arrayOf(PropTypes.object),
  balance: PropTypes.number,
  selected: PropTypes.bool,
  isCancelled: PropTypes.bool,
  onBowlerChange: PropTypes.func,
  onTeamChange: PropTypes.func,
  onSelectChecked: PropTypes.func,
  onCancelClick: PropTypes.func,
  onReactivateClick: PropTypes.func,
  onRefundClick: PropTypes.func
};

VirtualEntryDetail.defaultProps = {
  bowlers: [],
  teams: [],
  balance: 0
};

export default VirtualEntryDetail;



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEntry.jsx